import { render, staticRenderFns } from "./collectVideo.vue?vue&type=template&id=6748baaa&scoped=true&"
import script from "./collectVideo.vue?vue&type=script&lang=js&"
export * from "./collectVideo.vue?vue&type=script&lang=js&"
import style0 from "./collectVideo.vue?vue&type=style&index=0&id=6748baaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6748baaa",
  null
  
)

export default component.exports